import { ReactComponent as Deliveryman } from "assets/markers/deliveryman.svg"
import CustomMarker from "components/Organisms/map/CustomMarker"
import { BeatDetailQuery } from "generated/graphql"
import useLiveLocation from "pages/vehicle/trip/useLiveLocation"
import React from "react"
type BeatTrackingMarkerType = {
  assignee: BeatDetailQuery["beatDetail"]["assignee"]
}
const BeatTrackingMarker = ({ assignee }: BeatTrackingMarkerType) => {
  let { location, angle } = useLiveLocation(
    `starling:base_user/${assignee.referenceId}`
  )

  // We do this because the svg is already 90 degrees
  const finalAngle = angle + 90

  return (
    <>
      {location?.lat && location?.lng && (
        <CustomMarker
          top="-24px"
          left="-17px"
          className="transition-transform ease-in"
          position={location}
          style={{
            transform: `rotate(${finalAngle}deg)`,
          }}
        >
          <Deliveryman />
        </CustomMarker>
      )}
    </>
  )
}

export default BeatTrackingMarker
